import React, { Component } from 'react';
import { Button } from '@blueprintjs/core';

class AssignedUserCard extends Component {

	render() {
		const p = this.props;

		const pictureStyle = {
			backgroundImage: 'linear-gradient(to right, black, white)',
		}

		return (
			<div className={"AssignedUserCard"}>
				<div className="PMPictureRound" style={pictureStyle} />
				<h2><b>{p.user.firstName} {p.user.lastName.substring(0, 1)}</b></h2>
				{p.user.role}
				<Button
					minimal
					icon="minus"
					title="Remove User"
					intent="primary"
					onClick={() => p.removeAssigned(p.user)}
				/>
			</div>
		);
	}
}
export default AssignedUserCard;


// WEBPACK FOOTER //
// ./src/components/projectmanager/new/Assigned/AssignedUserCard.js